<mat-expansion-panel class="role" [expanded]="expanded" (opened)="load()">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{role_label}}
    </mat-panel-title>
    <mat-panel-description >
      {{role_description}}
    </mat-panel-description>
  </mat-expansion-panel-header>
  <mat-card appearance="outlined">
    <mat-card-content fxLayout="column">
      <mat-progress-bar [mode]="'indeterminate'" *ngIf="loadingRole"></mat-progress-bar>
      <div fxFlexAlign="end" *ngIf="canDeleteAccessBulk">
        <button mat-stroked-button
                color="warn"
                (click)="confirmDeleteAllAccess()">{{buttonDeleteAllAccess}}</button>
      </div>
      <form fxLayout="column">
        <app-search-ldap fxFlex="90"
                         [ldapDisplayProperty]="'cn,mail'"
                         [removeDiatrics]="true"
                         [placeHolder]="'Rechercher une personne puis la sélectionner pour l\'ajouter...'"
                         [scope]="scope"
                         [title]="false"
                         [defaultScopes]="defaultScopes"
                         [scopesToDisplay]="scopesToDisplay"
                         (ldapUserSelected)="onSelectIndiv($event)">

        </app-search-ldap>
      </form>
    </mat-card-content>
    <mat-card-content>
      <mat-chip-listbox>
        <mat-chip-option *ngFor="let role of roleEntites"
                      (removed)="confirmDeleteRole(role.id)">
          <span style="display: flex; align-items: center">
            <span>{{role.individu.last_name}} {{role.individu.first_name}} ({{role.individu.uid}})</span>
            <span>&nbsp;{{role.individu.email_pro}}</span>
            <span class="spacer"></span>
            <button matChipRemove *ngIf="! isIndConnected(role.individu)">
              <mat-icon class="mat-16">close</mat-icon>
            </button>
          </span>
        </mat-chip-option>
      </mat-chip-listbox>
    </mat-card-content>

  </mat-card>

</mat-expansion-panel>
